import { DataBean } from "../DataBean";

export class FixedStateConstants extends DataBean {


    public async getFixedAssetItemStateConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetItemStateConstants_Number", [id]);
    }
    
}